<template>
  <div class="user-page">
    <el-row class="user-page__row">
      <p class="page-form-title">Users page</p>
      <p class="page-form-tip">View user status, operate user.</p>
      <el-button
        icon="el-icon-refresh"
        @click.native="getUsers"
        :loading="isLoading"
        class="user-page__row-refresh"
        >REFRESH</el-button
      >
      <el-table :data="users" stripe style="width: 100%" v-loading="isLoading">
        <el-table-column prop="index" label="ID"> </el-table-column>
        <el-table-column prop="id" label="Name">
          <template slot-scope="scope">
            {{ scope.row.id.match(/(\S*)@/)[1] }}
          </template>
        </el-table-column>
        <el-table-column prop="roles" label="Role">
          <template slot-scope="scope">
            <el-tag
              type="primary"
              disable-transitions
              v-for="(item, index) in scope.row.roles"
              :key="index"
              class="user-page__tags"
              >{{ item }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Operations">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleDetail(scope.$index, scope.row)"
              >DETAIL</el-button
            >
            <el-button
              size="mini"
              @click="handleDisable(scope.$index, scope.row)"
              type="danger"
              v-if="
                scope.row.roles.includes('user') &&
                  !scope.row.roles.includes('admin') &&
                  !scope.row.roles.includes('data')
              "
              >DISABLE</el-button
            >
            <el-button
              size="mini"
              @click="handleEnable(scope.$index, scope.row)"
              type="success"
              v-if="
                !scope.row.roles.includes('user') &&
                  !scope.row.roles.includes('admin')
              "
              >ENABLE</el-button
            >
            <el-button
              size="mini"
              @click="handleRefund(scope.row)"
              type="warning"
              v-if="
                scope.row.roles.includes('user') &&
                  !scope.row.roles.includes('admin') &&
                  !scope.row.roles.includes('data')
              "
              >REFUND</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="page"
        :page-size="per_page"
        @current-change="getUsers"
        class="user-page__pagination"
      >
      </el-pagination>
    </el-row>
    <el-dialog title="Refund" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="Refund Asset Id" prop="assetId">
          <el-input
            name="assetId"
            v-model="form.assetId"
            autocomplete="off"
            placeholder="Please enter the asset id."
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="Refund Amount" prop="amount">
          <el-input
            name="amount"
            v-model="form.amount"
            autocomplete="off"
            placeholder="Please enter the asset amount."
          ></el-input>
        </el-form-item>
        <el-form-item label="Private Key" prop="privateKey">
          <el-input
            name="privateKey"
            v-model="form.privateKey"
            autocomplete="off"
            placeholder="Please enter the admin private key."
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="onSubmit" :loading="confirmLoading"
          >Confirm</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cachedInfo from '../util/global'
import { mapActions } from 'vuex'

export default {
  name: 'users-page',

  data() {
    return {
      users: undefined,
      isLoading: false,
      selectedUser: undefined,
      form: {
        assetId: 'pla',
        amount: undefined,
        privateKey: undefined
      },
      dialogFormVisible: false,
      confirmLoading: false,
      chosenUser: undefined,
      total: null,
      per_page: 15,
      page: 1,
      cachedInfo
    }
  },

  computed: {
    rules() {
      const amountRegexp =
        this.maxDecimalDigits !== 0
          ? RegExp(`^([1-9][0-9]*|0)(\\.[0-9]{1,${this.maxDecimalDigits}})?$`)
          : RegExp(`^[1-9][0-9]*$`)
      const amountMessage =
        this.maxDecimalDigits !== 0
          ? `"AMOUNT" should be a number of max ${
            this.maxDecimalDigits
          } decimal digits.`
          : `"AMOUNT" should be an integer.`
      return {
        assetId: [
          {
            required: true,
            message: 'Please enter asset id',
            trigger: 'change'
          },
          {
            pattern: /^[a-z_0-9]{1,32}$/,
            message: 'Asset id should match [a-z_0-9]{1,32}',
            trigger: 'change'
          }
        ],
        amount: [
          {
            required: true,
            message: 'Please enter "AMOUNT"',
            trigger: 'change'
          },
          { pattern: amountRegexp, message: amountMessage, trigger: 'change' }
        ],
        privateKey: [
          {
            required: true,
            message: 'Please enter "PRIVATE KEY"',
            trigger: 'change'
          },
          {
            pattern: /^[A-Fa-f0-9]{64}$/,
            message: '"PRIVATE KEY" should match [A-Fa-f0-9]{64}',
            trigger: 'change'
          }
        ]
      }
    }
  },

  methods: {
    ...mapActions(['detachRole', 'appendRole']),
    handleDetail(index, row) {
      this.$router.push({
        name: 'user-detail-page',
        params: { name: row.id }
      })
    },
    handleDisable(index, row) {
      this.$prompt(
        'If you are sure to disable this user, please enter the private key.',
        'Comfirm',
        {
          confirmButtonText: 'Comfirm',
          cancelButtonText: 'Cancel',
          inputPattern: /^[A-Fa-f0-9]{64}$/,
          inputErrorMessage: 'Private key has to be 64 characters in length.',
          inputPlaceholder: 'Please enter the admin private key'
        }
      ).then(({ value }) => {
        this.onDisable(row, value)
      })
    },
    onDisable(user, privateKey) {
      this.isLoading = true
      this.detachRole({
        accountId: user.id,
        roleName: 'user',
        privateKeys: [privateKey]
      })
        .then(() => {
          setTimeout(() => {
            this.getUsers()
          }, 1000)
        })
        .catch((err) => {
          this.isLoading = false
          console.log(err)
        })
    },
    handleEnable(index, row) {
      this.$prompt(
        'If you are sure to enable this user, please enter the private key.',
        'Comfirm',
        {
          confirmButtonText: 'Comfirm',
          cancelButtonText: 'Cancel',
          inputPattern: /^[A-Fa-f0-9]{64}$/,
          inputErrorMessage: 'Private key has to be 64 characters in length.',
          inputPlaceholder: 'Please enter the admin private key'
        }
      ).then(({ value }) => {
        this.onEnable(row, value)
      })
    },
    onEnable(user, privateKey) {
      this.isLoading = true
      this.appendRole({
        accountId: user.id,
        roleName: 'user',
        privateKeys: [privateKey]
      })
        .then(() => {
          setTimeout(() => {
            this.getUsers()
          }, 1000)
        })
        .catch((err) => {
          this.isLoading = false
          console.log(err)
        })
    },
    handleRefund(row) {
      this.chosenUser = row
      this.dialogFormVisible = true
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.confirmLoading = true
          this.refund()
        } else {
          return false
        }
      })
    },
    refund() {
      this.$store
        .dispatch('addAssetQuantity', {
          privateKeys: [this.form.privateKey],
          assetId: `${this.form.assetId}#${this.cachedInfo.currencyNode}`,
          amount: this.form.amount
        })
        .then(() => {
          this.transferAsset()
        })
        .catch((err) => {
          this.$alert(err.message, 'Transfer error', {
            type: 'error'
          })
        })
    },
    transferAsset() {
      this.$store
        .dispatch('transferAsset', {
          privateKeys: [this.form.privateKey],
          assetId: `${this.form.assetId}#${this.cachedInfo.currencyNode}`,
          to: this.chosenUser.id,
          amount: this.form.amount,
          description: 'REFUND TRANSACTION'
        })
        .then(() => {
          this.$message({
            message: 'Refund successful!',
            type: 'success'
          })
          this.confirmLoading = false
          setTimeout(() => {
            this.dialogFormVisible = false
          }, 1000)
        })
        .catch((err) => {
          this.$alert(err.message, 'Transfer error', {
            type: 'error'
          })
        })
    },
    getUsers() {
      this.isLoading = true
      this.$axios({
        method: 'get',
        url: '/api/accounts',
        params: {
          page: this.page,
          per_page: this.per_page
        }
      })
        .then((response) => {
          this.total = parseInt(response.headers['x-total'])
          this.users = response.data
          this.isLoading = false
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    }
  },

  created() {
    this.getUsers()
  }
}
</script>

<style scoped lang="scss">
.user-page {
  &__row {
    padding: 2rem;
    &-refresh {
      margin-bottom: 1rem;
    }
  }
  &__tags {
    margin: 0.1rem;
  }
  &__pagination {
    margin-top: 2rem;
  }
}

@media only screen and (max-width: 768px) {
  .el-button {
    margin-left: 0 !important;
    margin-bottom: 10px;
  }
}
</style>